ACC.search = {
  searchAddress: function() {
    /* eslint-disable  no-undef */
    var markInstance = new Mark(document.querySelector('#cboxWrapper .context'));
    var keywordInput = document.querySelector('#cboxWrapper #myInput');

    function performMark() {
      var keyword = keywordInput.value;

      var listSelector = document.querySelectorAll('.ph-list');

      [].forEach.call(listSelector, function(element) {
        element.parentNode.parentNode.style.display = '';
      });
      markInstance.unmark();

      if (keyword) {
        markInstance.mark(keyword, {
          done: function() {
            $('.ph-list').parents('.existing_address').not(':has(mark)').hide();

            if ($('.ph-list').parents('.existing_address').not(':has(mark)').is(':hidden')) {
              if ($('#cboxWrapper .existing_address').is(':visible')) {
                $('.ph-resultnotfound').hide();
              } else {
                $('.ph-resultnotfound').show();
              }
            } else {
              $('.ph-resultnotfound').hide();
            }
          },
          separateWordSearch: false,
          exclude: [
            'button',
            'ph-resultnotfound'
          ]
        });
      } else {
        $('.ph-resultnotfound').hide();
      }
    }

    if (keywordInput !== 'null') {
      keywordInput.addEventListener('input', performMark);
    }
  /* eslint-enable  no-undef */
  }
};
